import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { providePrimeNG } from "primeng/config";
import { TranslateModule } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

import Aura from "@primeng/themes/aura";

// Tema personalizado con color primario VIRA (azul #358fd6)
const viraTheme = {
  ...Aura,
  semantic: {
    ...Aura.semantic,
    primary: {
      ...Aura.semantic?.primary,
      50: "#eaf5fc",
      100: "#d7e9f7",
      200: "#aed2ef",
      300: "#86bce6",
      400: "#5da5de",
      500: "#358fd6",
      600: "#2a72ab",
      700: "#205680",
      800: "#153956",
      900: "#0b1d2b",
      950: "#050e16",
    },
  },
};

import { routes } from "./app.routes";
import { authInterceptor } from "./guards/auth.interceptor";
import { es } from "primelocale/es.json";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    providePrimeNG({
      translation: es,
      theme: {
        preset: viraTheme,
        options: {
          prefix: "vira",
          darkModeSelector: ".my-app-dark",
        },
      },
    }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: "es",
        loader: provideTranslateHttpLoader({ prefix: "./assets/i18n/", suffix: ".json" }),
      })
    ),
  ],
};
